document.addEventListener('DOMContentLoaded', function () {
    let isUpdating = false;

    function updateCart(variantId, quantity, input, button = null) {
        if (isUpdating) return;
        isUpdating = true;

        if (button) button.disabled = true;

        fetch('/cart/change.js', {
            method: 'POST',
            headers: { 'Content-Type': 'application/json' },
            body: JSON.stringify({ id: variantId, quantity: quantity })
        })
        .then(response => response.json())
        .then(() => refreshCartDrawer())
        .finally(() => {
            isUpdating = false;
            if (button) button.disabled = false;
        });
    }

    function refreshCartDrawer() {
        fetch('/cart')
            .then(response => response.text())
            .then(html => {
                let parser = new DOMParser();
                let doc = parser.parseFromString(html, 'text/html');
                let newCartDrawer = doc.querySelector('.cart-drawer');
                let cartDrawer = document.querySelector('.cart-drawer');

                if (cartDrawer && newCartDrawer) {
                    cartDrawer.innerHTML = newCartDrawer.innerHTML;
                }

                attachEventListeners();
            });
    }

    function attachEventListeners() {
        document.querySelectorAll('.quantity__button').forEach(button => {
            button.removeEventListener('click', quantityChangeHandler);
            button.addEventListener('click', quantityChangeHandler);
        });

        document.querySelectorAll('.quantity__input').forEach(input => {
            input.removeEventListener('change', manualQuantityChangeHandler);
            input.addEventListener('change', manualQuantityChangeHandler);
        });

        document.querySelectorAll('.cart-drawer-item__cart-remove-button button').forEach(button => {
            button.removeEventListener('click', removeItemHandler);
            button.addEventListener('click', removeItemHandler);
        });

        document.querySelectorAll('[name="add"]').forEach(button => {
            button.removeEventListener('click', addToCartAndRefresh);
            button.addEventListener('click', addToCartAndRefresh);
        });

        document.querySelectorAll('.product-form [type="submit"]').forEach(button => {
            button.removeEventListener('click', addVariantToCartAndRefresh);
            button.addEventListener('click', addVariantToCartAndRefresh);
        });
    }

    function addToCartAndRefresh(event) {
        event.preventDefault();
        let form = event.target.closest('form');
        let formData = new FormData(form);

        fetch('/cart/add.js', {
            method: 'POST',
            body: formData
        })
        .then(response => response.json())
        .then(() => {
            setTimeout(() => {
                localStorage.setItem('cartDrawerOpen', 'true');
                location.reload();
            }, 500);
        });
    }

    function addVariantToCartAndRefresh(event) {
        event.preventDefault();
        let form = event.target.closest('.product-form');
        let formData = new FormData(form);

        fetch('/cart/add.js', {
            method: 'POST',
            body: formData
        })
        .then(response => response.json())
        .then(() => {
            setTimeout(() => {
                localStorage.setItem('cartDrawerOpen', 'true');
                location.reload();
            }, 500);
        });
    }

    function quantityChangeHandler(event) {
        if (isUpdating) return;
        let input = this.closest('.cart-item__quantity-wrapper').querySelector('.quantity__input');
        let variantId = input.getAttribute('data-quantity-variant-id');
        let currentQuantity = parseInt(input.value);
        let newQuantity = this.name === 'plus' ? currentQuantity + 1 : Math.max(1, currentQuantity - 1);

        updateCart(variantId, newQuantity, input, this);
    }

    function manualQuantityChangeHandler(event) {
        let input = event.target;
        let variantId = input.getAttribute('data-quantity-variant-id');
        let newQuantity = parseInt(input.value);

        if (isNaN(newQuantity) || newQuantity < 1) {
            newQuantity = 1;
            input.value = 1;
        }

        updateCart(variantId, newQuantity, input);
    }

    function removeItemHandler(event) {
        event.preventDefault();
        if (isUpdating) return;
        let button = this;
        let variantId = button.closest('.cart-drawer-item').querySelector('.quantity__input').getAttribute('data-quantity-variant-id');

        updateCart(variantId, 0, button);
    }

    function openCartDrawer() {
        if (localStorage.getItem('cartDrawerOpen') === 'true') {
            setTimeout(() => {
                let cartDrawer = document.querySelector('.cart-drawer');
                if (cartDrawer) {
                    cartDrawer.classList.add('active');
                }
                localStorage.removeItem('cartDrawerOpen');
            }, 500);
        }
    }

    attachEventListeners();
    openCartDrawer();
});